export default {
  SET_PLACES(state, places) {
    state.places = places
  },
  SET_PLACE(state, place) {
    state.place = place
  },
  ADD_PLACE_SERVICE(state, payload) {
    state.place.services.push(payload)
  },
  UPDATE_PLACE_SERVICE(state, payload) {
    state.place.services = state.place.services.filter(e => e.id !== payload.id)
    state.place.services.push(payload)
  },
  DELETE_PLACE_SERVICE(state, serviceId) {
    state.place.services = state.place.services.filter(e => e.id !== serviceId)
  },
  SET_PLACES_COUNT(state, count) {
    state.placesCount = count
  },
  SET_PLACES_QUERY(state, query) {
    state.query = query
  },
  SET_PLACES_LIMIT(state, limit) {
    state.limit = limit
  },
  SET_PLACES_SKIP(state, skip) {
    state.skip = skip
  },
  SET_PLACES_SORT(state, sort) {
    state.sort = sort
  }
}
